import React from "react";

import AfterNoonIcon from "../../images/icons/afternoon-icon.inline.svg";
import MorningIcon from "../../images/icons/morning-icon.inline.svg";
import NightIcon from "../../images/icons/night-icon.inline.svg";
import Image from "../image";

const ActivityTimeIcon = ({ id, iconClass = "" }) => {
  const icons = {
    0: <MorningIcon className={iconClass} />,
    1: <AfterNoonIcon className={iconClass} />,
    2: <NightIcon className={iconClass} />
  };

  return icons[id] || icons[0];
};
const ItineraryUnit = ({ unit, unitClass, prefix = "Day" }) => {
  return (
    <div className={unitClass}>
      <h3
        className="font-medium text-base flex flex-col flex-1 p-2 text-center"
        dangerouslySetInnerHTML={{ __html: `${prefix} ${unit}` }}
      />
    </div>
  );
};

const ItineraryCard = ({
  title,
  description,
  itineraryUnit,
  itineraryPrefix = "Day",
  itineraryFeatureImageSourceUrl,
  itineraryActivityList = []
}) => {
  return (
    <div className="outer-container dark:bg-gray-darker bg-secondary-bg rounded-md flex flex-col sm:flex-row h-full">
      <div className="left-side-container relative w-full sm:w-1/3 2xl:w-1/4">
        <ItineraryUnit
          unit={itineraryUnit}
          prefix={itineraryPrefix}
          unitClass={
            "flex absolute dark:gvi-gray-bg bg-white rounded-b-xs w-20 left-8 z-20"
          }
        />

        <Image
          imageClass={
            "sm:absolute top-0 left-0 right-0 bottom-0 z-10 rounded-t-md h-40 w-full sm:rounded-l-md sm:rounded-r-none sm:h-full sm:w-auto object-cover object-center"
          }
          imageAlt={""}
          image={""}
          sourceUrl={itineraryFeatureImageSourceUrl}
        />
      </div>

      <div className="bh-block-content p-6 flex flex-1 flex-col">
        <h6
          className="font-bold dark:text-gray-generic text-black-lighter min-h-16 sm:min-h-4"
          dangerouslySetInnerHTML={{
            __html: title
          }}
        />

        {description && (
          <div
            className="text-generic-text dark:text-gray-septenary text-sm tab-content_html py-4"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        {itineraryActivityList?.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-3 divide-y-0 md:divide-y-0 md:divide-x divide-[#BEB38B] pt-4 md:py-6">
            {itineraryActivityList?.map((activity, index) => (
              <>
                <div className="flex items-center md:flex-col gap-2 md:gap-5 first:pl-0 last:pr-0 py-2 md:py-0 md:px-6 ">
                  <div className="w-1/6 md:w-full flex items-center justify-start h-6">
                    {ActivityTimeIcon({
                      id: index,
                      iconClass: "md:w-auto md:h-7 fill-yellow-standard"
                    })}
                  </div>
                  <div
                    className="flex-1 show-br dark:text-gray-generic text-black-lighter text-sm"
                    dangerouslySetInnerHTML={{
                      __html: activity?.desc
                    }}
                  />
                </div>
              </>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default ItineraryCard;
